import { render, staticRenderFns } from "./AdminSignup.vue?vue&type=template&id=3a2c8ae8&scoped=true"
import script from "./AdminSignup.vue?vue&type=script&lang=js"
export * from "./AdminSignup.vue?vue&type=script&lang=js"
import style0 from "./AdminSignup.vue?vue&type=style&index=0&id=3a2c8ae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2c8ae8",
  null
  
)

export default component.exports